import{derived} from "svelte/store";
import{config} from "./ConfigStore";
import {state} from "./StateStore";

// create the context list, that is used to build the overlay
export const context = derived( [ config, state ], ( [ $config, $state ] ) => {
	const failover = $config.contexts.find( item => item.id === 'default' )

	// no context necessary
	if ( ! $state.context ) {
		return failover
	}

	const found = $config.contexts.find( item => item.id === $state.context )

	return found ? { ...found } : { ...failover }
} )
